import { createContext, useContext, useEffect, useState } from "react";
import {
  createTranslator,
  formatDate as formatDateValue,
  formatDateTime as formatDateTimeValue,
  formatTime as formatTimeValue,
  getCurrentLocale,
  normalizeLocale,
  setStoredLocaleOverride,
} from "../i18n";
import { applySyncfusionLocale } from "../i18n/syncfusion";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => getCurrentLocale());

  useEffect(() => {
    applySyncfusionLocale(locale);
  }, [locale]);

  const setLocale = (nextLocale) => {
    const normalized = normalizeLocale(nextLocale);
    setStoredLocaleOverride(normalized);
    setLocaleState(normalized);
  };

  const value = {
    locale,
    setLocale,
    t: createTranslator(locale),
    formatDate: (value, options) => formatDateValue(value, options, locale),
    formatTime: (value, options) => formatTimeValue(value, options, locale),
    formatDateTime: (value, options) =>
      formatDateTimeValue(value, options, locale),
  };

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useI18n must be used within an I18nProvider");
  }
  return context;
}
